import { TStringField } from '../../../../types/types';
import { TSocialLink, TSocialMediaBarProps } from '../types/socialMediaBar.types';

export class SocialMediaBarModel {
  private readonly items: TSocialMediaBarProps['items'];
  private readonly title: TSocialMediaBarProps['title'];

  constructor(props: TSocialMediaBarProps) {
    this.items = props.items;
    this.title = props.title;
  }

  get socialText(): TStringField | undefined {
    return this.title;
  }

  get socialLinksItems(): TSocialLink[] | undefined {
    return this.items?.slice(0, 4);
  }
}
